import { apiCall } from '@/utils/apiAxios';
import { actionMap } from '@/utils/actionMap';
import { useAuthStore } from '@/stores/auth';

export function useUserAction() {

    const authStore = useAuthStore();

    async function registerUserAction(shortName: string) {
        const actionId = actionMap[shortName];
        if (!actionId) {
            console.warn(`Acción desconocida: ${shortName}`);
            return;
        }

        const sessionHash = authStore.sessionHash;
        if (!sessionHash) {
            console.warn('No hay session_hash disponible.');
            return;
        }

        const agentHash = sessionStorage.getItem('agentHash');
        if (!agentHash) {
            console.warn('No hay agent_hash disponible.');
            return;
        }

        apiCall({
            method: 'post',
            url: '/brokerin/api/users_session/register_user_action',
            data: {
            session_hash: sessionHash,
            action_id: actionId,
            agent_hash: agentHash,
            }
          });
    }

    return { registerUserAction };
}
